import { useCallback } from 'react';
import { useGameState, useGameDispatch } from '../GameProvider';
import { moveCardToRow, moveCardToStaging, tapStagingCard, tapRowCard, tapSlot, swapCards } from '../gameActions';

export function useDragAndDrop() {
  const state = useGameState();
  const dispatch = useGameDispatch();

  const handleDropOnSlot = useCallback((card, targetRow, targetIndex) => {
    const { arrangement } = state;

    // Is the card currently in a row?
    let sourceRow = null;
    for (const row of ['bottom', 'middle', 'top']) {
      const idx = arrangement[row].findIndex(c => c.id === card.id);
      if (idx !== -1) { sourceRow = row; break; }
    }

    // Is the target slot occupied?
    const targetCard = arrangement[targetRow]?.[targetIndex];

    if (sourceRow && targetCard) {
      dispatch(swapCards(card, targetCard, sourceRow, targetRow));
    } else if (sourceRow && !targetCard) {
      dispatch(moveCardToRow(card, targetRow, targetIndex));
    } else if (!sourceRow && targetCard) {
      dispatch(moveCardToStaging(targetCard));
      dispatch(moveCardToRow(card, targetRow, targetIndex));
    } else {
      dispatch(moveCardToRow(card, targetRow, targetIndex));
    }
  }, [state, dispatch]);

  const handleDropOnStaging = useCallback((card) => {
    dispatch(moveCardToStaging(card));
    dispatch({ type: 'SET_SELECTED_CARD', card: null });
  }, [dispatch]);

  const handleTapStaging = useCallback((card) => {
    dispatch(tapStagingCard(card));
  }, [dispatch]);

  const handleTapRow = useCallback((card, row, index) => {
    dispatch(tapRowCard(card, row, index));
  }, [dispatch]);

  const handleTapSlot = useCallback((row, index) => {
    dispatch(tapSlot(row, index));
  }, [dispatch]);

  return {
    handleDropOnSlot,
    handleDropOnStaging,
    handleTapStaging,
    handleTapRow,
    handleTapSlot,
  };
}
